/**
 * @file Components/Ui/ServiceCard.jsx
 * @description Reusable service card UI component with expandable details,
 * icon, title, description, and feature list for the services section.
 */

import React from 'react';

const ServiceCard = ({ icon, title, description, features }) => {
  return (
    <div className="bg-white p-2 rounded-lg shadow-lg flex-1 flex flex-col">
      <div className="p-6 flex-1">
        <div className="text-3xl mb-4 flex gap-4">
          <div>{icon}</div>
          <div>
            <h3 className="text-xl font-bold mb-4 text-center">{title}</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-4">{description}</p>
        <ul>
          {features.map((feature, index) => (
            <li key={index} className="flex justify-between items-center mb-2">
              <span className="text-black">{feature.name}</span>
              <span>{feature.available ? '✅' : '❌'}</span>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
};

export default ServiceCard;

